module.exports = __webpack_public_path__ + "img/exhibition6.5611148e.png";